<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-05-23 18:04:12
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-27 12:05:40
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/affiliationDialog/components/hintDialog/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
  <el-dialog title="提示" :visible.sync="dialogVisible" width="420px" :before-close="handleClose">
    <div class="content">
      <i class="el-icon-warning"></i>
      <div class="ml-4">
        <div>修改订单量较大，系统需要几分钟进行处理。处理结果可</div>
        <div>在<span class="update-log" @click="goToPage">修改记录</span>中进行查看。</div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确认分配</el-button>
    </span>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce';
export default {
  name: 'hintDialog',
  props: {
    platformId: {
      type: [String,Number],
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    submit: debounce(function() {
      this.$emit('submit')
      this.handleClose()
    }, 500),
    goToPage() {
      const { href } = this.$router.resolve({
        path: '/order/updateLog',query: { platformId: this.platformId }
      });
      window.open(href)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 8px;
  display: flex;
  color: #333;
  line-height: 24px;
  .el-icon-warning {
    color: #FA8F14;
    margin-top: 4px;
  }
  .update-log {
    cursor: pointer;
    color: @color-primary;
  }
}
</style>
